'use strict';

import GraphQL from './graphql';

const pageSize = 5;

export default {

  get (list, noteableId, noteableType, cursor) {
    const query = `{
      notes(
        noteableId:${noteableId},
        noteableType:"${noteableType}",
        first:${pageSize},
        after:"${cursor}",
        list:"${list}"
      ) {
        totalCount
        pageInfo {
          hasNextPage
        }
        edges {
          node {
            id
            title
            body
            status
            author_name
            created_at
            attachments {
              edges {
                node {
                  filename
                  file_extension
                  file_size
                  url
                }
              }
            }
          }
          cursor
        }
      }
    }`;

    return GraphQL.post(query);
  },

  create (noteableId, noteableType, note, attachmentTempUrls) {
    const query = `mutation {
      createNote(
        noteableId: ${noteableId},
        noteableType: "${noteableType}",
        title: "${note.title}",
        body: "${note.body}",
        status: "${note.status}",
        noteTypeIds: ${JSON.stringify(note.noteTypeIds)},
        attachmentUrls: ${JSON.stringify(attachmentTempUrls)}
      ) {
          id
          title
          body
          status
          author_name
          created_at
          attachments {
            edges {
              node {
                filename
                file_extension
                file_size
                url
              }
            }
          }
        }
    }`;

    return GraphQL.post(query);
  }

};



// WEBPACK FOOTER //
// ./app/javascript/vue/services/notes.js